package Structs

import DataBase.UINKDBInterface
import kotlinx.serialization.Serializable

@Serializable
data class NoteSignHolder(
    val note_id: Int,
    val note_type:Int,
    val digi_sign:Int,
    val digi_photo:Int,
    val signer: String,
    val date: String,
) {
    fun hasPhoto(): Boolean = digi_photo > 0
    fun photoCount(): Int = count(digi_photo)

    companion object {
        const val MAX_PHOTOS = 3
        fun hasPhoto(n: Int?): Boolean = (n ?: 0) > 0
        fun count(n: Int?): Int = (n ?: 0).coerceIn(0, MAX_PHOTOS)
        fun s3Suffix(index: Int): String = if (index <= 0) "" else "_$index"
    }
}